<template>
    <v-btn
      :color="color"
      @click="$emit('click')"
      :disabled="disabled"
      class="base-button"
    >
      <slot>Submit</slot>
    </v-btn>
  </template>
  
  <script lang="ts" setup>
  import { defineProps } from 'vue';

  const props = defineProps<{
    color?: string;      
    disabled?: boolean; 
  }>();
  </script>
  
  <style scoped>
  .base-button {
    font-weight: 600;
    border-radius: 4px; 
    padding: 10px 20px; 
  }
  </style>
  